module.exports = __webpack_public_path__ + "static/img/COC2021-18.3f6f468.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-18.jpg
// module id = +Clb
// module chunks = 0